import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
const STEPS_KEYS = [
    { id: 1, key: 'progressVerifyIdentity' },
    { id: 2, key: 'progressConnectBank' },
    { id: 3, key: 'progressAuthentication' },
    { id: 4, key: 'progressPickAccount' },
    { id: 5, key: 'progressSummary' }
];

const circleSize = 40;
const activeColor = 'var(--brand-green-dark)';
const lineColor = 'var(--disabled-color)';

function getStepColor(stepId, currentStep) {
    if (stepId === currentStep) return '#fff';
    if (stepId < currentStep) return '#000';
    return '#A6A6A6';
}

function ProgressBar({ currentStep }) {
    const { t } = useTranslation();
    // The line should start at the center of the first circle and end at the center of the last circle
    // So, left = (circleSize/2)px, width = calc(100% - circleSize)
    return (
        <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>   
            <div
                style={{
                    position: 'relative',
                    width: '1000px',
                    height: 64,
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center'
            }}
        >
            {/* The line behind the steps, starting/ending at the center of the first/last circle */}
            <div
                style={{
                    position: 'absolute',
                    top: circleSize / 2,
                    left: circleSize / 2,
                    width: `calc(102% - ${circleSize}px)`,
                    height: 2,
                    background: lineColor,
                    zIndex: 0
                    
                }}
            />
            {/* The steps */}
            {STEPS_KEYS.map((step, idx) => {
                const percent = (idx / (STEPS_KEYS.length - 1)) * 100;
                return (
                    <div
                        key={step.id}
                        style={{
                            position: 'absolute',
                            left: `calc(${percent}% - ${circleSize / 2}px)`,
                            top: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: circleSize * 2,
                            zIndex: 1
                        }}
                    >
                        <div
                            style={{
                                width: circleSize,
                                height: circleSize,
                                borderRadius: '50%',
                                background:
                                    step.id === currentStep
                                        ? activeColor
                                        : '#fff',
                                border: `2px solid ${
                                    step.id === currentStep
                                        ? activeColor
                                        : lineColor
                                }`,
                                color: getStepColor(step.id, currentStep),
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: 8,
                                fontWeight: 500,
                                fontSize: 16,
                                position: 'relative'
                            }}
                        >
                            {step.id < currentStep ? (
                                <CheckIcon fontSize="small" />
                            ) : (
                                step.id
                            )}
                        </div>
                        <div
                            style={{
                                fontSize: '0.98rem',
                                color: '#222',
                                marginBottom: 0,
                                marginTop: 0,
                                whiteSpace: 'nowrap',
                                textAlign: 'center'
                            }}
                        >
                            {t(step.key)}
                        </div>
                    </div>
                );
            })}
        </div>
        </div>
    );
}

ProgressBar.propTypes = {
    currentStep: PropTypes.number.isRequired
};

export default ProgressBar; 